import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";
import { useLang } from "@/contexts/LangContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const { t } = useLang();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const u = await login(email, password);
      const from = location.state?.from || (u.role === "admin" ? "/admin" : "/cuenta");
      navigate(from, { replace: true });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
      setSubmitting(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 md:px-12 py-24 fade-in" data-testid="login-page">
      <p className="tracking-eyebrow text-[var(--eafg-muted)]">{t("auth.loginSubtitle")}</p>
      <h1 className="font-serif-display text-5xl mt-3 mb-10">{t("auth.loginTitle")}</h1>

      <form onSubmit={submit} className="space-y-6" data-testid="login-form">
        <label className="block">
          <span className="tracking-eyebrow text-[var(--eafg-muted)] block mb-2">{t("auth.email")}</span>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full border-b border-[var(--eafg-line)] bg-transparent py-2 focus:outline-none focus:border-[var(--eafg-ink)]"
            data-testid="login-email"
          />
        </label>
        <label className="block">
          <span className="tracking-eyebrow text-[var(--eafg-muted)] block mb-2">
            {t("auth.password")}
          </span>
          <input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full border-b border-[var(--eafg-line)] bg-transparent py-2 focus:outline-none focus:border-[var(--eafg-ink)]"
            data-testid="login-password"
          />
        </label>
        <button
          type="submit"
          disabled={submitting}
          className="w-full bg-[var(--eafg-ink)] text-white py-4 tracking-eyebrow hover:bg-[var(--eafg-copper)] transition-colors disabled:opacity-50"
          data-testid="login-submit"
        >
          {t("auth.submitLogin")}
        </button>
        <p className="text-sm text-[var(--eafg-muted)]">
          {t("auth.noAccount")}{" "}
          <Link to="/registro" className="underline hover:text-[var(--eafg-copper)]">
            {t("auth.submitRegister")}
          </Link>
        </p>
        <p className="text-sm text-[var(--eafg-muted)]">
          <Link to="/recuperar-password" className="underline hover:text-[var(--eafg-copper)]" data-testid="login-forgot-link">
            {t("auth.forgot")}
          </Link>
        </p>
      </form>
    </div>
  );
}
